import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page, query) {
  return request({
    url:    `/page-content/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params:  query
  });
}

function create(values) {
  return request({
    url:    '/page-content/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/page-content/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/page-content/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/page-content/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

const PageContentService = {
  get, create, update, remove, find
}

export default PageContentService;
